import { ApplicationStatus } from '@/apis/family_application/requests'
import { AppRoutePaths } from '@/routing/route_paths'
import { RootState } from '@/storage/store'
import React from 'react'
import { useSelector } from 'react-redux'
import { isValidRoute } from './application-status.utils'
import { useAppeals } from '@/apis/user_appeals/useAppeals'

interface Props {
  children: React.ReactNode
  pathname: string
  notAllowedFallbackComponent?: React.ReactNode | null
}

function ApplicationStatusAuthorization({ children, pathname }: Props) {
  const programSettings = useSelector(
    (state: RootState) => state.ProgramSettings
  )
  const { data } = useSelector((state: RootState) => state.FamilyApplication)
  const appeals = useAppeals()
  const statuses: ApplicationStatus[] = data?.students.map(
    (student) => student.application_status
  ) ?? ['Invited']

  if (appeals.status === 'pending' || appeals.status === 'error') {
    return <></>
  }

  if (!programSettings.data) {
    return <></>
  }

  const valid = statuses.some((status) =>
    isValidRoute({
      pathname,
      applicantStatus: status,
      programSettings: programSettings.data!,
    })
  )

  // This should be null.
  // But to not disrupt devs testing, we'll return the children.
  const TEMPORARY_FALLBACK_FOR_TO_NOT_DISRUPT_TESTING = children
  const shouldDisplayClassWallet = valid && programSettings.data.class_wallet

  // Temporary.
  if (
    pathname === AppRoutePaths.external.classWallet &&
    !shouldDisplayClassWallet
  ) {
    return null
  }

  return valid ? children : TEMPORARY_FALLBACK_FOR_TO_NOT_DISRUPT_TESTING
}

export { ApplicationStatusAuthorization }
